/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import React from 'react';
import { object } from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import ReactMarkdown from 'react-markdown';
import { Box } from '@material-ui/core';
import transformRenderer from '../../../../../../helpers/markdown/characterTransformer';

const useStyles = makeStyles((theme) => ({
    copyContainer: {
        display: 'flex',
        padding: '0px 10px',
        margin: '48px auto 36px',
        flexDirection: 'column',
        maxWidth: '700px',
        [theme?.breakpoints?.down('600')]: {
            padding: '0px 16px',
            margin: '32px auto 14px',
        },
    },
    copy: {
        display: 'flex',
        flexDirection: 'column',
        '& p': {
            fontSize: '18px',
            lineHeight: '23px',
            letterSpacing: '0.5px',
            paddingBottom: '20px',
            [theme?.breakpoints?.down('600')]: {
                fontSize: '16px',
                lineHeight: '21px',
            },
        },

    },
    heading: {
        display: 'flex',
        alignItems: 'center',
        fontSize: '40px',
        lineHeight: '45px',
        paddingBottom: '20px',
        [theme?.breakpoints?.down('600')]: {
            fontSize: '32px',
            lineHeight: '37px',
        },
    },
}));

const StoryCopy = ({
    data,
}) => {
    if (data?.group?.length === 0) { return null; }
    const classes = useStyles();
    return (
        <div className={classes.copyContainer}>
            {data.group.map((item) => (
                <>
                    {item?.heading
                    && (
                        <Box sx={{
                            fontFamily: 'var(--comp-base-font-family-decorative)',
                        }}
                        ><ReactMarkdown className={classes.heading} renderers={transformRenderer} source={item.heading} escapeHtml={false} />
                        </Box>
                    )}
                    {item?.copy && (
                        <Box sx={{
                            fontFamily: 'var(--comp-base-font-family-default)',
                        }}
                        >
                            <ReactMarkdown className={classes.copy} renderers={transformRenderer} source={item.copy} escapeHtml={false} />
                        </Box>
                    )}
                </>
            ))}
        </div>
    );
};

StoryCopy.propTypes = {
    data: object.isRequired,
};

export default StoryCopy;
